export const buildDocumentoResumo = ({
  totalFuncionarios,
  totalAssinados,
  totalRecusados,
  finalizacaoAssinada,
  assinaturas = null,
} = {}) => {
  let total = Number(totalFuncionarios || 0);
  let assinados = Number(totalAssinados || 0);
  let recusados = Number(totalRecusados || 0);
  let finalizacaoOk = finalizacaoAssinada === true;

  if (Array.isArray(assinaturas)) {
    const funcionarios = assinaturas.filter((ass) => ass.tipo === 'funcionario');
    total = funcionarios.length;
    assinados = funcionarios.filter((ass) => ass.status === 'assinado').length;
    recusados = funcionarios.filter((ass) => ass.status === 'recusado').length;
    finalizacaoOk = assinaturas.some((ass) => ass.tipo === 'finalizacao' && ass.status === 'assinado');
  }

  const respondidos = assinados + recusados;
  const pendentes = Math.max(total - respondidos, 0);
  const pct = total > 0 ? Math.round((respondidos / total) * 100) : 0;
  const tudoRespondido = total > 0 && pendentes === 0;

  return {
    total,
    assinados,
    recusados,
    respondidos,
    pendentes,
    finalizacaoOk,
    pct,
    tudoRespondido,
    concluido: finalizacaoOk && tudoRespondido,
  };
};

export const getDocumentoCardDisplay = (resumo) => {
  const {
    total,
    assinados,
    recusados,
    respondidos,
    pendentes,
    finalizacaoOk,
    pct,
    tudoRespondido,
  } = resumo;

  const detalhePartes = [];
  if (assinados > 0) {
    detalhePartes.push(assinados === 1 ? '1 confirmou' : `${assinados} confirmaram`);
  }
  if (recusados > 0) {
    detalhePartes.push(recusados === 1 ? '1 recusou' : `${recusados} recusaram`);
  }
  const detalhe = detalhePartes.join(' · ');

  if (finalizacaoOk) {
    const cor = pendentes > 0 ? '#eab308' : '#22c55e';
    const subtitulo = pendentes > 0
      ? `${pendentes} pendente${pendentes !== 1 ? 's' : ''} de assinar · ${respondidos}/${total} responderam`
      : `${respondidos}/${total} responderam no app`;

    return {
      cor,
      titulo: 'Rota finalizada',
      subtitulo,
      detalhe: detalhe || null,
      progresso: pct,
    };
  }

  if (tudoRespondido) {
    return {
      cor: '#eab308',
      titulo: `${respondidos}/${total} responderam`,
      subtitulo: 'Aguardando finalização do motorista',
      detalhe: detalhe || null,
      progresso: pct,
    };
  }

  return {
    cor: pct >= 50 ? '#eab308' : '#f97316',
    titulo: `${respondidos}/${total} responderam`,
    subtitulo: pendentes > 0
      ? `${pendentes} pendente${pendentes !== 1 ? 's' : ''}${detalhe ? ` · ${detalhe}` : ''}`
      : detalhe || `${pct}% do grupo`,
    detalhe: null,
    progresso: pct,
  };
};
